import styled from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    width: 100vw;
    background: ${props => props.theme.legacyScss['theme-background']};
`;

export const LoaderWrapper = styled.div`
    height: 26px;
`;
